export default [
    {
        path: 'alterar-horario',
        component: () => import(
            '@/views/transporte-paciente/alterar-horario/Index'
        ),
        redirect: 'alterar-horario/list',
        children: [
            {
                name: 'alterar-horario-list',
                path: 'list',
                component: () => import(
                    '@/views/transporte-paciente/alterar-horario/List'
                ),
            },
        ],
    },
]